import { CurrentOrderActionType } from './actions';
import { initialState } from './constants';
import { CurrentOrderState, CurrentOrderAction } from './types';

export const currentOrderReducer = (
  state: CurrentOrderState = initialState,
  action: CurrentOrderAction
): CurrentOrderState => {
  switch (action.type) {
    case CurrentOrderActionType.setCurrentOrder:
      return {
        order: action.payload,
        errorType: null,
      };
    case CurrentOrderActionType.setCurrentOrderError:
      return {
        order: null,
        errorType: action.payload,
      };
    case CurrentOrderActionType.resetCurrentOrderError:
      return {
        order: state.order,
        errorType: null,
      };
    case CurrentOrderActionType.resetCurrentOrder:
      return {
        order: null,
        errorType: state.errorType,
      };
    default:
      return state;
  }
};
